import React, { FC, useCallback, type ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';
import { EXTERNAL_PATHS } from 'src/common/constants';
import ActionsDropdown from '../ActionsDropdown';
import type { DropdownOption } from '../DropdownDS22';
import IconDS22, { IconIds } from '../IconDS22';
import style from './Navigation.module.scss';

type NavItemDropdownProps = {
  children: ReactNode;
  classNameModifier?: string;
  icon?: IconIds;
  options: DropdownOption[];
};

const NavItemDropdown: FC<NavItemDropdownProps> = ({
  children,
  classNameModifier = '',
  icon,
  options,
}) => {
  const content = (
    <>
      {icon && (
        <IconDS22
          id={icon}
          size="l"
          className={getClassName(style, 'icon', classNameModifier)}
        />
      )}
      <span className={getClassName(style, 'children', classNameModifier)}>
        {children}
      </span>
    </>
  );

  const handleDropdownItemSelect = useCallback(({ id = '' }: DropdownOption) => {
    if (Object.values(EXTERNAL_PATHS).includes(id)) {
      window.location.assign(id);
    }
  }, []);

  return (
    <ActionsDropdown
      dropdownPosition="right"
      label={content}
      handleSelect={handleDropdownItemSelect}
      options={options}
      showCaret={false}
      variant="topNav"
    />
  );
};

export default NavItemDropdown;
